// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3zIfq","title":"Images45_title__pyPGS","images":"Images45_images__1saGd"};